export const MenuItemsEnum = {
  Home: 1,
  Contact: 2,
  Text: 3,
  Email: 4,
  Phone: 5,
  VideoMessage: 6,
  Bio: 7,
  SocialMedia: 8,
  Gallery: 9,
  Blog: 10,
  Reviews: 11,
  AboutUs: 12,
  MeetTheTeam: 13,
  CompanyVideo: 14,
  Map: 15,
  ShareToFriends: 16,
  MyReferrals: 17,
  Shop: 18,
  Specials: 19,
  LoanCalculator: 20,
  ManufacturerBrochures: 21,
  MyVehicles: 22,
  MyFavorites: 23,
  OwnersManuals: 24,
  ScheduleService: 25,
  MyProfile: 26,
  AddToPhone: 27,
  ContactUs: 28,
  About: 29,
  DealerInfo: 30,
  Refer: 31,
  MyGarage: 32
}



// WEBPACK FOOTER //
// ./scripts/src/shared/enums/menu.items.js